export const HOME_SCHEMA = {
  en: {
    hero_heading: "Your financial life, built around you.",
    hero_description:
      "Trusted experts. Intelligent tools. One place for every financial decision.",
    cta_hero: "Get Started",
    hero_image_alt: "Plaintr Tax Filing",
    video_bg_support: "Your browser does not support the video tag.",
    how_it_works: {
      title: "How It Works",
      steps: [
        {
          icon: "/images/icons/apply_light_blue.svg",
          title: "Get started",
          description:
            "Create your account and bring your financial life into one place.",
        },
        {
          icon: "/images/icons/promote_light_blue.svg",
          title: "Use what you need",
          description: "Choose what fits your life, whenever you need it.",
        },
      ],
    },
    product_ecosystem: {
      tax_filing: {
        heading: "Tax Filing",
        description: "A better way to file",
        cta: "Start Your Filing",
        expert_heading: "File With an Expert",
        expert_content: [
          "Not every tax situation fits into a simple flow.",
          "Plaintr connects you with a certified expert who understands your case, guides you through what matters, and prepares everything for your approval before filing.",
        ],
        audiences_heading:
          "For real-life tax situations that need real expertise",
        audiences: [
          {
            src: "multistate_filer.svg",
            title: "Multi-state",
            desc: "Remote job in one state, home in another? We handle that.From part-year residency to equity received from an out-of-state employer, certified pros get multi-state filings right.",
          },
          {
            src: "crypto_filer.svg",
            title: "Crypto",
            desc: "If your portfolio got bigger, your taxes got harder.We match you with pros who understand modern investing.",
          },
          {
            src: "selfemp_filer.svg",
            title: "Self-Employed",
            desc: "One-person business, many moving parts. Get matched with a pro who knows Schedule C inside and out.",
          },
          {
            src: "profesional_filer.svg",
            title: "Professional",
            desc: "You shouldn't need to be an accountant to file your own taxes. Let a certified pro handle the complexity.",
          },
          {
            src: "owner_filer.svg",
            title: "Business & Properties Owner",
            desc: "Airbnb, rental income, depreciation, and expenses — done right. Certified pros ensure real-estate accuracy.",
          },
          {
            src: "highincome_filer.svg",
            title: "High Income",
            desc: "Sold equity? Earned bonuses? Multiple income streams? Your pro ensures accuracy and compliance.",
          },
        ],
        benefits_heading: "Benefits",
        benefits: [
          "Matched with a certified tax expert who fits your needs",
          "Pricing that reflects your situation — clear from the start",
          "Real support from start to finish",
        ],
      },
      financial_insights: {
        heading: "Financial Insights",
        description: "A better way to understand your money.",
        cta: "Explore Insights",
        intro_heading: "Your Financial Life, Simplified",
        intro_content: [
          "Your financial life is always changing. The challenge isn't finding more information—it's understanding what it all means.",
          "Plaintr connects every part of your financial life in one place, helping you see what's changing, recognize patterns, plan ahead, and make every financial decision with confidence.",
        ],
        features_carousel: {
          heading: "See The Story",
        },
        insights_card: {
          title: "Focus On What Matters",
          description: "The best financial decisions begin with perspective.",
        },
      },
    },
    blog: {
      heading: "Decoded by Plaintr",
      cta: "View All",
    },
    affiliates: {
      heading: "Turn trust into income.",
      badge: "Plaintr Affiliates",
      image_alt: "Plaintr Affiliates",
      description:
        "Recommend financial tools and services you genuinely believe in. When people you trust choose Plaintr, you earn along the way.",
      cta: "Learn More",
    },
    faq: {
      heading: "Your Questions Answered",
      cta: "View All",
      toggle_alt: {
        open: "Open",
        close: "Close",
      },
      items: [
        {
          title: "What is Plaintr and how does it work?",
          description:
            "Plaintr was built for people whose lives don’t fit into forms. We start with your story — what you do, how you earn, what changed this year — and from there, our Smart Match system connects you with a certified expert who fits your exact situation. Every match is personal. Every fee is upfront. Every payment is protected through a secure payment hold powered by Stripe, one of the most trusted payment platforms in the world. No mystery quotes. No hidden add-ons. Just a clear, human process designed to take the fear out of filing — and bring confidence back in.",
        },
        {
          title: "Who are the professionals working with Plaintr?",
          description:
            "Every professional on Plaintr is a Certified Public Accountant (CPA), Enrolled Agent (EA), or Tax Attorney. We personally verify their credentials, licenses, and identities before they join. No gig workers. No seasonal hires. Just credentialed experts who understand the tax code — and the people behind it.",
        },
        {
          title: "How do payments work — and why do we charge upfront?",
          description:
            "At Plaintr, you know exactly what you’ll pay before you start. Your personalized flat fee is created for your specific case once Smart Match pairs you with the right pro. Once you accept, your payment is placed under a secure payment hold through Stripe until your case is complete and you approve the work.",
        },
      ],
    },
    closing_page: {
      heading: "Your Financial Home",
      description: "Where every part of your financial life works together.",
      ctas: [
        { text: "Get Started", link: "/sign-up" },
        { text: "Log In", link: "/sign-in" },
      ],
    },
    q_and_a_title: "Frequently Asked Questions",
    cta_suggestions: {
      intro: "Ready when you are",
      links: [
        { text: "Sign In", link: "/sign-in", stl: "w" },
        { text: "Create Account", link: "/sign-up", stl: "w" },
        { text: "How We Match You", link: "/how-it-works", stl: "b" },
      ],
    },
  },
};
